import type { UpdateTileLayerConfig, WamFile } from "@workadventure/map-editor";
import { TilemapEditsManager, UpdateTileLayerCommand } from "@workadventure/map-editor";
import type { GameMapFrontWrapper } from "../../../GameMap/GameMapFrontWrapper";
import type { FrontCommandInterface } from "../FrontCommandInterface";
import type { RoomConnection } from "../../../../../Connection/RoomConnection";

export class UpdateTileLayerFrontCommand extends UpdateTileLayerCommand implements FrontCommandInterface {
    /** Snapshot of the patched fields before the update, used to build the undo command. */
    private readonly previousConfig: UpdateTileLayerConfig;

    constructor(
        wamFile: WamFile,
        layerId: number,
        config: UpdateTileLayerConfig,
        commandId: string | undefined,
        private gameMapFrontWrapper: GameMapFrontWrapper,
    ) {
        super(wamFile, layerId, config, commandId);
        const layer = TilemapEditsManager.findTileLayer(gameMapFrontWrapper.getMap(), layerId);
        this.previousConfig = {};
        if (layer) {
            if (config.name !== undefined) {
                this.previousConfig.name = layer.name;
            }
            if (config.opacity !== undefined) {
                this.previousConfig.opacity = layer.opacity ?? 1;
            }
            if (config.visible !== undefined) {
                this.previousConfig.visible = layer.visible ?? true;
            }
        }
    }

    public async execute(): Promise<void> {
        await super.execute();
        // Only the name goes through the sync pipeline for now: visibility/opacity remain
        // local-only editing aids (the proto already carries the optional fields for the future).
        if (this.config.name !== undefined) {
            this.gameMapFrontWrapper.renameTileLayerById(this.layerId, this.config.name);
        }
    }

    public getUndoCommand(): UpdateTileLayerFrontCommand {
        return new UpdateTileLayerFrontCommand(
            this.wamFile,
            this.layerId,
            this.previousConfig,
            undefined,
            this.gameMapFrontWrapper,
        );
    }

    public emitEvent(roomConnection: RoomConnection): void {
        roomConnection.emitMapEditorUpdateTileLayer(this.commandId, this.layerId, this.config);
    }
}
